var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('c-title',[_vm._v("Account bestätigen")]),_c('p',[_vm._v("Dieser Link ist leider nicht mehr gültig. Bitte geben Sie Ihre E-Mail-Adresse ein und fordern einen neuen Bestätigungslink an.")]),_c('c-resend-verification')],1)}
var staticRenderFns = []

export { render, staticRenderFns }